module.exports = __webpack_public_path__ + "static/img/20002 (3).cda8882.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20002 (3).webp
// module id = 67KW
// module chunks = 14